// Client-side edit reporting for the admin Activity view. A per-tab session id
// groups a user's modifications to a generated configuration; value-typed edits
// (quantities, order size) are debounced so typing doesn't flood the log.
import { config } from './config'

const KEY = 'bmw-soc-session-id'

export function sessionId(): string {
  let id = sessionStorage.getItem(KEY)
  if (!id) {
    id = crypto.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(16).slice(2)}`
    sessionStorage.setItem(KEY, id)
  }
  return id
}

// Headers for the logged API calls (predict/export) so they share the session.
export function sessionHeaders(base?: Record<string, string>): Record<string, string> {
  return { 'X-Session-Id': sessionId(), ...(base ?? {}) }
}

export function reportEdit(modelCodes: string[], summary: string): void {
  // Fire-and-forget; never block or surface errors to the user.
  fetch(`${config.apiUrl}/api/activity`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', 'X-Session-Id': sessionId() },
    body: JSON.stringify({ model_codes: modelCodes, summary }),
  }).catch(() => {})
}

const timers: Record<string, ReturnType<typeof setTimeout>> = {}

// Collapse rapid changes to the same thing (a row's qty, the order size) into a
// single report of the final value.
export function reportEditDebounced(key: string, modelCodes: string[], summary: string, ms = 900): void {
  if (timers[key]) clearTimeout(timers[key])
  timers[key] = setTimeout(() => reportEdit(modelCodes, summary), ms)
}
